/* eslint-disable no-param-reassign */

import { JiraSiteAri } from '@atlassian/ari/jira/site';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { fetchIssueRelayData } from '@atlassian/jira-issue-fetch-services-vendorless/src/services/issue-agg-data/index.tsx';
import { fetchIssueGiraData } from '@atlassian/jira-issue-fetch-services-vendorless/src/services/issue-gira-data/index.tsx';
import { fetchIssueGiraNonCriticalData } from '@atlassian/jira-issue-fetch-services-vendorless/src/services/issue-gira-non-critical-data/index.tsx';
import getMeta from '../get-meta.tsx';

const EARLY_FETCH_GIRA_KEY = 'ISSUE_GIRA_DATA';
const EARLY_FETCH_AGG_KEY = 'ISSUE_AGG_DATA';
const EARLY_FETCH_GIRA_NON_CRITICAL = 'ISSUE_GIRA_NON_CRITICAL_DATA';

// From strip-url-to-issue-key
const ISSUE_KEY_REGEXP = /(([A-Z0-9][A-Z0-9_]+)-([0-9]+))($|[?|#].*|\/embed)/;

export const stripUrlToIssueKey = (candidateUrl: string): string | null => {
	const match = candidateUrl.match(ISSUE_KEY_REGEXP);
	return match && match[1];
};

export const fetchIssueData = (win: typeof window) => {
	if (expVal('issue_view_ssr_perf_m2', 'isEnabled', false)) {
		return;
	}

	const { fetch, location } = win;
	if (!fetch) {
		return;
	}

	const { pathname, href } = location;
	if (!/^\/browse\/(?:\w+-\d+)/.test(pathname)) {
		return;
	}

	const issueKey = stripUrlToIssueKey(href);
	if (issueKey === null || issueKey === undefined) {
		return;
	}

	const projectKey = issueKey != null ? issueKey.split('-')[0] : '';

	performance.mark('issueViewEarlyScripts:clientRequestStart');

	performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_GIRA_KEY}:clientRequestStart`);

	const issueGiraDataPromise = fetchIssueGiraData(issueKey, projectKey);
	issueGiraDataPromise.then(() =>
		performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_GIRA_KEY}:getFromNetworkEnd`),
	);
	win[EARLY_FETCH_GIRA_KEY] = issueGiraDataPromise;
	performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_GIRA_KEY}:clientRequestEnd`);

	performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_AGG_KEY}:clientRequestStart`);
	const cloudId = getMeta('ajs-cloud-id') || '';
	const siteAri = JiraSiteAri.create({ siteId: cloudId }).toString();
	fetchIssueRelayData(issueKey, cloudId, siteAri);
	performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_AGG_KEY}:clientRequestEnd`);
	if (!fg('move_iv_noncriticalgiraquery_out_of_critical_path')) {
		performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_GIRA_NON_CRITICAL}:clientRequestStart`);

		const issueGiraNonCriticalDataPromise = fetchIssueGiraNonCriticalData(issueKey);
		issueGiraNonCriticalDataPromise.then(() =>
			performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_GIRA_NON_CRITICAL}:getFromNetworkEnd`),
		);
		win[EARLY_FETCH_GIRA_NON_CRITICAL] = issueGiraNonCriticalDataPromise;
		performance.mark(`issueViewEarlyScripts:${EARLY_FETCH_GIRA_NON_CRITICAL}:clientRequestEnd`);
	}

	performance.mark('issueViewEarlyScripts:clientRequestEnd');
};
